import { createContext, useContext } from 'react'

import type { MessageChannel } from '@oneToOne/shared/ws/message'

import { useMessageChannel } from './useMessageChannel'

const MessageChannelContext = createContext<MessageChannel | undefined>(
  undefined,
)

/** @returns The Message channel instance provided by the context. */
export function useMessageChannelContext(): MessageChannel | undefined {
  return useContext(MessageChannelContext)
}

/** Message channel instance context provider. */
export const MessageChannelProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const channel = useMessageChannel()

  return (
    <MessageChannelContext.Provider value={channel}>
      {children}
    </MessageChannelContext.Provider>
  )
}
